<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="手机号:">
              <el-input v-model.trim="table.where.mobile" maxlength="11" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="姓名:">
              <el-input v-model.trim="table.where.name" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="年级:">
              <treeselect
                v-model="table.where.id"
                :options="GradeTree"
                :disable-branch-nodes="true"
                placeholder="请选择所属年级"
                :defaultExpandLevel="4"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table class="table" ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="teacher_name" label="姓名" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="mobile" label="手机号" sortable="custom" show-overflow-tooltip min-width="110">
            <template #default="{ row }">{{ row.mobile | phoneSafe }}</template>
          </el-table-column>
          <el-table-column prop="branch_name" label="部系" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="grade_name" label="年级" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="class_name" label="班级" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column label="操作" width="210px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-popconfirm title="确定要删除此用户吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      title="设置用户"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="选择班级:">
              <treeselect
                v-model="editForm.classId"
                :options="ClassTree"
                :disable-branch-nodes="false"
                placeholder="请选择所属班级"
                :defaultExpandLevel="4"
                valueConsistsOf="LEAF_PRIORITY"
                :multiple="true"
                style="line-height: 20px"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                "
              />
            </el-form-item>
            <el-form-item label="选择老师:">
              <treeselect
                v-model="editForm.teacherIds"
                :options="deptTeacher"
                :disable-branch-nodes="true"
                placeholder="请选择老师"
                :defaultExpandLevel="2"
                :multiple="true"
                search-nested
                noChildrenText="该部门无人员"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                "
                style="line-height: 20px"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import { addTeacherStations, delTeacherPosition, getAllClassTree, getAllGradeTree, getAllDepartTeachers } from '@/config/api';

  export default {
    name: 'GroupteacherList',
    components: { Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/station/getTeacherGradePositionList',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          classId: [{ required: true, message: '请选择班级', trigger: 'change' }],
          teacherIds: [{ required: true, message: '请选择老师', trigger: 'change' }],
        },
        ClassTree: [], //年级树数据
        deptTeacher: [], //部门下老师数据
        where: {},
        GradeTree: [],
        // teacherCheckData:[],
      };
    },
    mounted() {
      this.querydeptTeacher(); // 查询角色列表
      this.queryClassTree(); //查询部门列表
      this.queryGradeTree();
    },
    methods: {
      /* 保存编辑 */
      save() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            // console.log(this.editForm)
            const loading = this.$loading({ lock: true });
            for (let i = 0; i < this.editForm.classId.length; i++) {
              this.editForm.classId[i] = this.editForm.classId[i].substr(1);
            }
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            formData.append('type', 1);
            addTeacherStations(formData)
              .then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              })
              .catch((e) => {
                loading.close();
                this.$message.error(e.message);
              });
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        delTeacherPosition(formData)
          .then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            loading.close();
            this.$message.error(e.message);
          });
      },
      /* 获取所有部门下的所有老师 树 */
      querydeptTeacher() {
        getAllDepartTeachers().then((res) => {
          if (res.data.resCode == 200) {
            this.deptTeacher = res.data.data;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      /* 查询班级树 */
      queryClassTree() {
        getAllClassTree().then((res) => {
          if (res.data.resCode == 200) {
            this.ClassTree.push(res.data.data);
            this.deleteChildren(this.ClassTree);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      /* 查询年级树 */
      queryGradeTree() {
        getAllGradeTree().then((res) => {
          if (res.data.resCode == 200) {
            this.GradeTree.push(res.data.data);
            this.deleteChildren(this.GradeTree);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].orgType !== 4) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },
    },
  };
</script>

<style scoped>
  .ele-block >>> .el-upload,
  .ele-block >>> .el-upload-dragger {
    width: 100%;
  }
</style>
